import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";

const ResourseApi = createApi({
    reducerPath: 'ResourseApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAllResourcesList: builder.mutation({
            query: (details) => ({
                url: '/Resource/GetAllResourcesList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditResources: builder.mutation({
            query: (details) => ({
                url: '/Resource/AddEditResources',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),

})

export const {
useGetAllResourcesListMutation,
useAddEditResourcesMutation
} = ResourseApi;

export default ResourseApi;